console.log("nihao")
// $("button.mobile-menu-nav").click(function(){
//     $(this).siblings('ul').slideToggle();
// })
document.querySelectorAll('button.mobile-menu-nav').forEach(function(e){
    e.addEventListener('click', function() {
        var isopen = this.getAttribute("aria-expanded")
        if(isopen == "true"){
            this.setAttribute("aria-expanded","false")
        }else{
            this.setAttribute("aria-expanded","true")
        }
        // const ul = this.nextElementSibling;

        // if (ul.style.display === 'block' || ul.style.display === '') {
        //     ul.style.display = 'none';
        // } else {
        //     ul.style.display = 'block';
        // }
    });
})